import { Avatar, AvatarFallback } from '@workspace/ui/components/avatar'
import { Badge } from '@workspace/ui/components/badge'
import { Crown, Trash2 } from 'lucide-react'
import type { SettingsUser } from '../types'

export function UserRow({
  member,
  isOwner,
  onRemove,
}: {
  member: SettingsUser
  isOwner?: boolean
  onRemove?: () => void
}) {
  return (
    <div className="flex items-center gap-4 px-5 py-3">
      <Avatar className="size-9">
        <AvatarFallback className="bg-elevated text-xs font-medium text-white">
          {member.initials}
        </AvatarFallback>
      </Avatar>

      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <p className="text-sm font-medium text-foreground">{member.name}</p>
          {member.role === 'OWNER' && (
            <Badge variant="outline" size="sm" className="gap-1 border-[#f97316]/20 text-[#f97316]">
              <Crown className="size-2.5" />
              Owner
            </Badge>
          )}
        </div>
        <p className="text-xs text-muted-foreground">{member.email}</p>
      </div>

      {isOwner && onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="flex size-8 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-destructive/10 hover:text-destructive"
          title="Remove member"
        >
          <Trash2 className="size-4" />
        </button>
      )}
    </div>
  )
}
